module.exports = __webpack_public_path__ + "media/images/lion-black-58f524da978ba85da1a39758f00c24ed.jpg";